<script setup lang="ts">
import type { ITimelineWeekLabel } from '@/utils/date.timeline.utils';

const props = defineProps<{
  label: ITimelineWeekLabel;
}>();
</script>

<template>
  <div class="flex items-baseline gap-xs py-sm text-secondary">
    <span class="text-base font-semibold">{{ props.label.label }}</span>
    <span class="text-footer">{{ props.label.weekNumber }}</span>
  </div>
</template>
